import React, {useRef, useEffect, useState}  from 'react';
//components
import View from './my-meetings-view';
//utils
import {OrganisationService} from '../../../utils/data-transfer';
//lib
import { withRouter } from 'react-router-dom';

const MyMeetingsContainer = (props) => {
  const {location} = props;
  const organisationService = useRef(new OrganisationService());
  const showMeetings = useRef(location.pathname === '/my-meetings');
  const [state, setState] = useState({
    isLoading: true,
    meetings: [],
    pastMeetings: []
  });

  useEffect(() => {
    const bootstrapComponent = async () => {
      let meetings = [];
      let pastMeetings = [];

      if (showMeetings.current) {
        meetings = (await organisationService.current.getMyUpcomingMeetings()).results;
        pastMeetings = (await organisationService.current.getMyPastMeetings()).results;
      } else {
        meetings = (await organisationService.current.getMyUpcomingEvents()).results;
        pastMeetings = (await organisationService.current.getMyPastEvents()).results;
      }

      setState(prevState => ({...prevState, isLoading: false, meetings, pastMeetings}));
    };

    bootstrapComponent();
  }, []);

  return (
    <View
      {...state}
      showMeetings={showMeetings}/>
  );
};

export default withRouter(MyMeetingsContainer);
